export const SET_PROGRESS_LOG = 'SET_PROGRESS_LOG'